[
  {
    "id": "GET-E8P-L306-001",
    "module": "Getalbegrip",
    "difficulty": 306,
    "question": "Een bacteriekolonie verdubbelt elke 20 minuten. Je begint met 100 bacteriën. Hoeveel zijn het er na 2 uur?",
    "options": [
      "6.400",
      "3.200",
      "1.200",
      "600"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "exponentieel",
    "familyId": "GET-EXPONENTIEEL",
    "explanation": "2 uur = 120 minuten. Dat zijn 6 periodes van 20 minuten. $100 \\times 2^6 = 100 \\times 64 = 6.400$.",
    "distractorExplanations": {
      "1": "Dat is na 1 uur en 40 minuten (5 keer).",
      "2": "Je hebt 100 x 12 gedaan.",
      "3": "Je hebt 100 x 6 gedaan."
    }
  },
  {
    "id": "GET-E8P-L306-002",
    "module": "Getalbegrip",
    "difficulty": 306,
    "question": "Wat is de binaire code voor het getal 5?",
    "options": [
      "101",
      "110",
      "100",
      "111"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "binair",
    "familyId": "GET-BINAIR",
    "explanation": "4 + 0 + 1 = 5. Dus 101 (1x4, 0x2, 1x1).",
    "distractorExplanations": {
      "1": "Dat is 6.",
      "2": "Dat is 4.",
      "3": "Dat is 7."
    }
  },
  {
    "id": "GET-E8P-L306-003",
    "module": "Getalbegrip",
    "difficulty": 306,
    "question": "Reken uit: $\\sqrt{16 + 9}$ =",
    "options": [
      "5",
      "7",
      "12",
      "25"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "wortel_som",
    "familyId": "GET-WORTEL",
    "explanation": "Eerst optellen: 16 + 9 = 25. De wortel van 25 is 5.",
    "distractorExplanations": {
      "1": "Wortel 16 + wortel 9 = 4 + 3 = 7. Fout!",
      "2": "Rekenfout.",
      "3": "Je bent de wortel vergeten te trekken."
    }
  },
  {
    "id": "GET-E8P-L306-004",
    "module": "Getalbegrip",
    "difficulty": 306,
    "question": "Als a = 3 en b = -2, wat is dan $a^2 + b$?",
    "options": [
      "7",
      "11",
      "1",
      "5"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "algebra_invullen",
    "familyId": "GET-ALGEBRA",
    "explanation": "$3^2 = 9$. $9 + -2 = 9 - 2 = 7$.",
    "distractorExplanations": {
      "1": "Je hebt 9 - (-2) gedaan.",
      "2": "Je hebt 3 + -2 gedaan.",
      "3": "Rekenfout."
    }
  },
  {
    "id": "GET-E8P-L306-005",
    "module": "Getalbegrip",
    "difficulty": 306,
    "question": "Hoeveel is 0,2 promille van 10.000?",
    "options": [
      "2",
      "20",
      "200",
      "0,2"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "promille",
    "familyId": "GET-PROMILLE",
    "explanation": "Promille is per duizend. 1 promille van 10.000 is 10. 0,2 promille is 0,2 $\\times$ 10 = 2.",
    "distractorExplanations": {
      "1": "Dat is 2 promille.",
      "2": "Dat is 2 procent.",
      "3": "Dat is 0,02 promille."
    }
  }
]